export const convertToUtcOffset = (timezoneString) => {
  const match = timezoneString?.match(/UTC([+-]\d{1,2}):?(\d{2})?/);

  const hours = parseInt(match?.[1], 10);
  const minutes = match?.[2] ? parseInt(match?.[2], 10) : 0;

  return hours + minutes / 60;
};
